// extracted by mini-css-extract-plugin
export var addButton = "_oo-0";
export var border = "_oo-8";
export var check = "_oo-h";
export var danger = "_oo-6";
export var dropdownContainer = "_oo-1";
export var editModalBody = "_oo-j";
export var footerContainer = "_oo-i";
export var fullWidth = "_oo-a";
export var hide = "_oo-9";
export var icon = "_oo-3";
export var input = "_oo-7";
export var inputFlex = "_oo-b";
export var inputWrapper = "_oo-c";
export var manualFocus = "_oo-5";
export var optionButton = "_oo-4";
export var pillWrapper = "_oo-e";
export var pointer = "_oo-2";
export var showOverflow = "_oo-f";
export var tagsFlex = "_oo-d";
export var xButton = "_oo-g";